import request from './request';

export default {
	async getExpenseCategories() {
		const response = await request.get('/app/expense-categories');
		return response;
	},
	async getPaymentMethods() {
		const response = await request.get('/app/payment-methods');
		return response;
	},
	async getCurrencies() {
		const response = await request.get('/app/currencies');
		return response;
	}
};
